export interface HelpTranslations {
  quickStart: string;
  quickStartDescriptor: string;
  faqs: string;
}

export const helpTranslationKeys: HelpTranslations = {
  quickStart: 'quickStart',
  quickStartDescriptor: 'quickStartDescriptor',
  faqs: 'faqs',
};

export const helpTranslationsEN: HelpTranslations = {
  quickStart: 'Quick Start',
  quickStartDescriptor: 'These documents contain helpful information for getting started. Click a link below to open the file.',
  faqs: 'FAQs',
};

export const helpTranslationsES: HelpTranslations = {
  quickStart: 'Inicio rápido',
  quickStartDescriptor: 'Estos documentos contienen información útil para comenzar. Haz clic en un enlace a continuación para abrir el archivo.',
  faqs: 'Preguntas frecuentes',
};
